import * as React from 'react';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { MappingLink } from 'src/containers/ProjectDiagram/types/diagram';
import { addDeletedData } from 'src/containers/ProjectDiagram/utils/addDeletedData';
import {
  DiagramModelCommitLayout,
  commitDiagramModel,
  commitDiagramWhileSkippingUndoManager,
} from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { isLink } from 'src/containers/ProjectDiagram/utils/graphObject';
import { removeMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeMapping';
import { removePartsFromSelection } from 'src/containers/ProjectDiagram/utils/removePartsFromSelection';

export const useRemoveResourceMapping = () => {
  const diagram = useDiagram();

  return React.useCallback(
    (mappingKey: string) => {
      if (!diagram) {
        return;
      }

      const link = diagram.findLinkForKey(mappingKey);

      if (!link || !isLink<MappingLink>(link, LinkCategory.MAPPING)) {
        return;
      }

      // remove link and label from selection before removing to trigger a `diagramChangedSelection` event
      const keysToRemove = new Set([link.data.key, ...link.data.labelKeys]);
      commitDiagramWhileSkippingUndoManager(
        diagram,
        (_, diagram) => removePartsFromSelection(keysToRemove)(diagram),
        DiagramTransaction.SET_DIAGRAM_SELECTION
      );
      commitDiagramModel(
        diagram,
        (model) => {
          addDeletedData([link.data])(model);
          removeMapping(link.data)(model);
        },
        { layout: DiagramModelCommitLayout.PARTIAL }
      );
    },
    [diagram]
  );
};
